import "./styles.less";

import React from "react";
import { useActiveFiltersTags } from "./ActiveFiltersTags.hook";
import { ClosePillIcon } from "shared-components/Components/CustomIcons/ClosePillIcon/web";
import useLocationExtraData from "src/hooks/locationExtraData/useLocationExtraData";

const ActiveFiltersTags = () => {
	const { filtersTagsToShow, changeFilters } = useActiveFiltersTags();
	const { setLocationText } = useLocationExtraData();

	const filtersTagsDisplay = filtersTagsToShow.filter((f)=>f.text)

	return (
		<div className="filter-tag-wrap">
			{filtersTagsDisplay.map((o, i) => {
				return (
					<span className="pill" key={o.key + "_" + i}>
						{o.deleteable &&
							<div
								className="close"
								onClick={() => {
									changeFilters(o.onChangeObject)
									if (o.key === "locations") setLocationText("");
								}}>
								<ClosePillIcon width={15} />
							</div>
						}
						{o.text}
					</span>

				);
			})}
		</div>
	);
};

export { ActiveFiltersTags };
